import cn from "classnames";
import styles from "./EditClientColor.module.scss";
import WithModal from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { IEditClientColorProps } from "./EditClientColor.props";
import { useEditClientColorControl } from "./useEditClientColorControl";
import Button from "@components/global/new/Button/Button";
import { ColorPicker } from "antd";
import Title from "@components/global/new/Title/Title";
import { makeColor } from "@utils/hexToRgb";

function EditClientColor({ ...props }: IEditClientColorProps) {
  if (!props.client) return null;

  const { email, name, color } = props.client;
  const control = useEditClientColorControl(props);
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Title>Client</Title>
        <h5>{name || email}</h5>
      </div>

      <div className={styles.content}>
        <label>Choose another color</label>
        <ColorPicker
          onChange={(_, hex) => control.onChooseColor(hex)}
          placement='top'
          defaultValue={color}
        >
          <div
            className={styles.client_color}
            style={{
              backgroundColor: control.color,
              color: makeColor(control.color),
            }}
          >
            {name || email}
          </div>
        </ColorPicker>

        <div className={styles.btns}>
          <Button onClick={props.handleDestroy} white>
            Cancel
          </Button>
          <Button onClick={control.onSave}>Save</Button>
        </div>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.EDIT_CLIENT_COLOR, EditClientColor);
